<template>
  <el-dialog :close-on-click-modal="false" title="" :visible.sync="isShow" width="40%">
    <el-table :data="data">
      <el-table-column label="合成文件名称">
        <template v-slot="scope">
          <span class="color-blue"> {{ $config.pageType[scope.row.pageType] || scope.row.pageType }} <!-- {{ $config.orderStatus[scope.row.orderStatus] || scope.row.orderStatus}} -->
            <!-- {{ scope.row.pageType === 'TEXT' ? '内页' : scope.row.pageType === 'COVER' ? '封皮' : scope.row.pageType === 'SINGLE' ? '单页' : '' }} -->
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <a :href="scope.row.renderedUrl" target="_blank" download="">查看</a>
          <a :href="scope.row.specialPrintPath" target="_blank" download="" v-if="scope.row.specialPrintPath" style="margin-left:10px;">详情</a>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import { getRenderPdf } from '@/api/oms'
import { getInfoByOutOrderItemNo } from '@/api/ots'
export default {
  name: 'render-dialog',
  data () {
    return {
      isShow: false,
      itemId: '',
      data: []
    }
  },
  methods: {
    show (itemId) {
      this.isShow = true
      this.itemId = itemId
      this.getRenderInfo()
    },
    hide () {
      this.isShow = false
    },
    getRenderInfo () {
      getInfoByOutOrderItemNo(this.itemId).then(res => {
        this.data = res.data.data.pageList
      })
    }
  }
}
</script>
<style scoped lang="less">
.orderstatus-dialog {
  position: fixed;
  width: 100%;
  top: 20%;

  .order-cn {
    background: #fff;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.34);
    width: 713px;
    height: 424px;
    border-radius: 8px;
    margin: 0 auto;
    padding: 22px 60px;
    box-sizing: border-box;

    i {
      float: right;
      font-size: 28px;
      overflow: hidden;
      height: 28px;
      cursor: pointer;
      color: #2a2a2a;
    }

    h3 {
      font-size: 24px;
      line-height: 40px;
      padding: 20px 0;
      color: #2a2a2a;
      margin-top: 15px;
      border-bottom: 1px solid #e8e8e8;
      font-weight: normal;
    }

    p {
      font-size: 18px;
      color: #2a2a2a;
      line-height: 30px;
      padding: 10px 0;
    }

    button {
      width: 110px;
      height: 46px;
      border-radius: 30px;
      color: #fff;
      font-size: 18px;
      background: #2a2a2a;
      outline: none;
      border: none;
      box-shadow: none;
      float: right;
      margin-top: 150px;
      cursor: pointer;
      margin-left: 15px;

      &:hover {
        opacity: 0.6;
      }
    }

    .cancel {
      background: #707070;
    }

    table {
      text-align: center;
      font-size: 16px;
      color: #1d1e1d;
      border-color: #e8e8e8;
      margin-top: 8px;
      max-height: 300px;

      tr {
        th {
          line-height: 50px;
          background: #f2f2f2;
          font-weight: normal;
        }

        td {
          line-height: 80px;
          color: #1d1e1d;
          font-weight: 100;
        }
      }
    }
  }

  position: fixed;
  width: 100%;
  top: 20%;

  .order-cn {
    background: #fff;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.34);
    width: 713px;
    height: 424px;
    border-radius: 8px;
    margin: 0 auto;
    padding: 22px 60px;
    box-sizing: border-box;

    i {
      float: right;
      font-size: 28px;
      overflow: hidden;
      height: 28px;
      cursor: pointer;
      color: #2a2a2a;
    }

    h3 {
      font-size: 24px;
      line-height: 40px;
      padding: 20px 0;
      color: #2a2a2a;
      margin-top: 15px;
      border-bottom: 1px solid #e8e8e8;
      font-weight: normal;
    }

    p {
      font-size: 18px;
      color: #2a2a2a;
      line-height: 30px;
      padding: 10px 0;
    }

    button {
      width: 110px;
      height: 46px;
      border-radius: 30px;
      color: #fff;
      font-size: 18px;
      background: #2a2a2a;
      outline: none;
      border: none;
      box-shadow: none;
      float: right;
      margin-top: 150px;
      cursor: pointer;
      margin-left: 15px;

      &:hover {
        opacity: 0.6;
      }
    }

    .cancel {
      background: #707070;
    }

    table {
      text-align: center;
      font-size: 16px;
      color: #1d1e1d;
      border-color: #e8e8e8;
      margin-top: 8px;
      max-height: 300px;

      tr {
        th {
          line-height: 50px;
          background: #f2f2f2;
          font-weight: normal;
        }

        td {
          line-height: 80px;
          color: #1d1e1d;
          font-weight: 100;
        }
      }
    }
  }
}
</style>
